/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import LicenseContainer from '../LicenseContainer/LicenseContainer';

import styles from './MXRegulators.module.scss';

const MXRegulators = ({
  // title,
  shrunk = false,
  centered = false,
  noText = false,
}) => {
  const regulatorsClass = classNames({
    [styles.regulations]: true,
    [styles['regulations--shrunk']]: shrunk,
    [styles['regulations--centered']]: centered,
  });

  return (
    <div className={regulatorsClass}>
      {
        // TODO: add back the title when there is at least 1 logo
        // title ? <div className={styles.title}>{title}</div> : null
      }
      {noText ? null : <LicenseContainer />}
    </div>
  );
};

MXRegulators.propTypes = {
  // title: PropTypes.string,
  shrunk: PropTypes.bool,
  centered: PropTypes.bool,
  noText: PropTypes.bool,
};

export default MXRegulators;
